var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"switch_instruction--heading"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_c('p',{staticClass:"switch_instruction--text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }